// auth types
export default {
  UPDATE_SEARCH_TERM: 'UPDATE_SEARCH_TERM',
  UPDATE_SEARCH_RESULTS: 'UPDATE_SEARCH_RESULTS',
  CLEAR_SEARCH: 'CLEAR_SEARCH',
};
